import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
const ErrorStrip = ({ type, err }) => {
    return (
        err[type] ?
            <div styleName={"styles.errorText"} >
                {err[type].errorMessage}
            </div>
            : null
    );
};

ErrorStrip.propTypes = {
    type: PropTypes.string,
    err: PropTypes.object
};

export default ErrorStrip;
